/**
 * 管理后台 - 捐赠人管理 API
 */

import { httpGet, httpPost, httpPut, httpDelete } from '@/services/http';
import { transformDonor, transformDonorToBackend, BackendDonor, FrontendDonor } from '@/services/transform';

/** GET /api/admin/donors - 列出所有捐赠人 */
export async function getAdminDonors(): Promise<FrontendDonor[]> {
  try {
    const data = await httpGet<BackendDonor[]>('/admin/donors');
    return data.map(transformDonor);
  } catch (error) {
    console.error('获取管理捐赠人列表失败:', error);
    return [];
  }
}

/** POST /api/admin/donors - 创建捐赠人 */
export async function createAdminDonor(data: Partial<FrontendDonor>): Promise<FrontendDonor | null> {
  try {
    const backendData = transformDonorToBackend(data);
    const result = await httpPost<BackendDonor>('/admin/donors', backendData);
    return transformDonor(result);
  } catch (error) {
    console.error('创建捐赠人失败:', error);
    return null;
  }
}

/** PUT /api/admin/donors/:id - 更新捐赠人 */
export async function updateAdminDonor(id: string, data: Partial<FrontendDonor>): Promise<FrontendDonor | null> {
  try {
    const backendData = transformDonorToBackend(data);
    const result = await httpPut<BackendDonor>(`/admin/donors/${id}`, backendData);
    return transformDonor(result);
  } catch (error) {
    console.error('更新捐赠人失败:', error);
    return null;
  }
}

/** DELETE /api/admin/donors/:id - 删除捐赠人 */
export async function deleteAdminDonor(id: string): Promise<boolean> {
  try {
    await httpDelete(`/admin/donors/${id}`);
    return true;
  } catch (error) {
    console.error('删除捐赠人失败:', error);
    return false;
  }
}
